<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row class="table-header" v-if="userPermissions.indexOf('tradeWithdraw_create') != -1">
          <el-col>
            <el-tooltip effect="dark" content="创建配置" placement="top-start"  v-if="userPermissions.indexOf('tradeWithdraw_create') != -1 && buttonType=='icon'" >
              <el-button type="primary" size="medium" icon="iconfont icon-tianjiacaidan2" @click="addButton(0)"></el-button>
            </el-tooltip>
            <el-button type="primary" size="medium" icon="iconfont"  v-if="userPermissions.indexOf('tradeWithdraw_create') != -1 && buttonType=='text'"  @click="addButton(0)">创建配置</el-button>
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form size="medium" :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="姓名">
              <el-input v-model="searchCondition.bank_account_name" placeholder="输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="身份证">
              <el-input v-model="searchCondition.id_number" placeholder="输入身份证号" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row class="second-row">
          <ScreeCompany
            :allowField="allowField"
            @ScreeCompany="ScreeCompany" />
          <div class="table-right">
            <MonthPicker @MonthSearch="MonthSearch"/>
            <el-select v-model="value" placeholder="请选择导出类型" @change="selectData" class="select-box" size="medium">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button :loading="downloadLoading" style="margin:0 0 20px 20px;" type="primary" size="medium" icon="el-icon-document" @click="handleDownload">
              导出
            </el-button>
          </div>
        </el-row>
        <ApeTable ref="apeTable" style="font-size:12px;" :data="tradeWithdrawList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            slot="first-column"
            align="center"
            label="公司名称">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.outer_trade_no" placement="top">
                <div type="text">{{ scope.row.company_name}}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            align="center"
            prop="bank_account_name"
            sortable
            label="姓名">
            <template slot-scope="scope">
              {{ scope.row.bank_account_name }}
            </template>
          </el-table-column>
          <el-table-column
            slot="first-column"
            prop="money"
            align="center"
            sortable
            label="金额">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag type="success">¥ {{scope.row.money}}</el-tag>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            slot="first-column"
            prop="pay_fee"
            align="center"
            sortable
            label="服务费">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag type="success">¥ {{scope.row.pay_fee}}</el-tag>
              </div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            slot="first-column"
            prop="balance_money"
            align="center"
            sortable
            label="账户余额">
            <template slot-scope="scope">
              <div class="tag-group">
                <el-tag type="success">¥ {{scope.row.balance_money}}</el-tag>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            slot="first-column"
            align="center"
            label="税源地">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.outer_trade_no" placement="top">
                <div type="text">{{ scope.row.channel_name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column
            slot="first-column"
            align="center"
            label="服务费">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.pay_fee" placement="top">
                <div type="text">{{ scope.row.pay_fee }}</div>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <el-table-column
            slot="first-column"
            align="center"
            label="税率类型">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.rate_type  == 1 ? '外扣' : '内扣'  " placement="top">
                <div type="text">{{ scope.row.rate_type == 1 ? '外扣' : '内扣'  }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
         
          <!-- <el-table-column
            v-if="buttonType=='text'"
            width="160"
            label="操作">
            <template slot-scope="scope">
              <span>
                <el-button size="mini" type="default" v-if="userPermissions.indexOf('tradeWithdraw_view') != -1"  @click="viewButton(scope.row.id)">详情</el-button>
                <el-button size="mini" type="default" v-if="userPermissions.indexOf('tradeWithdraw_edit') != -1"  @click="editButton(scope.row.id)">编辑</el-button>
                <el-popover
                  v-if="userPermissions.indexOf('tradeWithdraw_delete') != -1"
                  placement="top"
                  width="150"
                  v-model="scope.row.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini">删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="alias_msg"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-button size="medium" @click="mxViewReceipt(scope.row.outer_trade_no)" type="success" plain>查看电子回单</el-button>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="dialogRules" ref="tradeWithdrawAttacmentForm" label-position="right" label-width="96px">
          <el-form-item label="名称" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="附件" prop="attachment">
            <ApeUploader :limit="1" :isImage="false" :allowSize="1024*1024*500" :allowTypeList="attachmentType" @handleUploadSuccess="handleAttachmentUploadSuccess" @handleUploadRemove="handleAttachmentUploadRemove" :upload-file-list="attachmentUploadFileList"></ApeUploader>
          </el-form-item>
          <el-form-item label="备注" prop="intro">
            <el-input type="textarea" v-model="formData.intro"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import ScreeCompany from '@/components/ScreeCompany.vue'
import MonthPicker from '@/components/MonthPicker.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
    ScreeCompany,
    MonthPicker
  },
  data() {
    return {
      // 允许显示的字段
      allowField: ['cardAttribute', 'sendStatus', 'companyId', 'settlementId','multiple'],
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      //导出表格类型
      bookType: 'xlsx',
      searchCategory: [],
      // 搜索条件
      downloadLoading: false,
      options: [{
          value: 'xlsx',
          label: 'xlsx'
        }, {
          value: 'csv',
          label: 'csv'
        }, {
          value: 'txt',
          label: 'txt'
        }
      ],
      value: 'xlsx',
      searchCondition:{
        card_attribute: '',
        send_status: ''
      },
      loadingStaus: true,
      columns: [
        // {
        //   title: '订单号',
        //   value: 'outer_trade_no',
        //   header_align: 'center',
        //   align: 'center',
        // },
        // {
        //   title: '公司名称',
        //   value: 'company_name',
        //   header_align: 'center',
        //   align: 'center',
        // },
        // {
        //   title: '姓名',
        //   header_align: 'center',
        //   align: 'center',
        //   value: 'bank_account_name',
        // },
        // {
        //   title: '金额',
        //   value: 'money',
        //   header_align: 'center',
        //   align: 'center',
        // },
        {
          title: '附属信息',
          header_align: 'center',
         /*  align: 'center', */
          value: [
            {label:'证件：',value:'id_number'},
            {label:'账户：',value:'bank_account_no'},
            {label:'卡属性：',value:'alias_card_attribute'},
            {label:'备注：',value:'remark'},
            {label:'分行号：',value:'bank_line_no'},
            {label:'支行名称：',value:'bank_branch'},
            {label:'错误代码：',value:'error_code'},
            {label:'错误信息：',value:'error_msg'},
            {label:'银行渠道：',value:'pid'}
          ],
          width: 280
        },
        // {
        //   title: '异步通知',
        //   header_align: 'center',
        //   align: 'center',
        //   value: 'notify_msg'
        // },
        {
          title: '推送时间',
          header_align: 'center',
          align: 'center',
          value: 'push_time',
        },
        {
          title: '状态',
          header_align: 'center',
          align: 'center',
          value: 'send_msg',
        },
        {
          title: '创建时间',
          header_align: 'center',
          align: 'center',
          width: 200,
          value: 'created_at',
        }
      ],
      // 表格列表数据
      tradeWithdrawList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        // direction: 'right',
        title: '',
        width_height: '640px',
        show_footer:false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList:[],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: '标题',
          value: 'title',
        }
      ],
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentTradeWithdrawId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    // 导出日期
    MonthSearch(v) {
      if (v) {
        this.searchCondition.month = v
      } else {
        console.log("删除筛选")
        delete this.searchCondition.month
        delete this.searchCondition.time
      }
      this.init('search')
    },
    ScreeCompany(v, name) {
      if (name == 'company') {
        console.log(v);
        console.log(v[0]);
        console.log(v.includes(''));
        if(v.length !== 0 && !v.includes('')) {
          console.log(1);
          this.searchCondition.company_ids = v
        } else {
          console.log(2);
          // this.$set(this.searchCondition.company_ids,'')
          delete this.searchCondition.company_ids
        }
        this.init('search')
      }

      if(name == 'settlement') {
        console.log(v);
        if (v.length !== 0 && !v.includes('')) {
          this.searchCondition.channel_accounts = v
        } else {
          delete this.searchCondition.channel_accounts
        }
        this.init('search')
      }

      if(name == 'cardAttribute') {
        if (v) {
          this.searchCondition.card_attribute = v
        } else {
          delete this.searchCondition.card_attribute
        }
        this.init('search')
      }

      if(name == 'sendStatus') {
        if (v) {
          this.searchCondition.send_status = v
        } else {
          delete this.searchCondition.send_status
        }
        this.init('search')
      }
    },
    // 搜索
    searchButton() {
      this.init()
    },
    selectData(e) {
      this.bookType = e;
    },
    //导出
    async handleDownload() {
      this.isExport = true;
      this.downloadLoading = true
      let list = await this.init('export')
      import('@/excel/Export2Excel').then( excel => {
        const tHeader = ['公司名称', '订单号', '姓名', '身份证号', '实发金额','税源地名称','税率类型（1 外扣，2内扣）','卡属性: （C 对私，B 对公）', '备注', '状态', '错误代码', '错误信息', '下发时间'];
        const data = this.formatJson(list)
        const time = new Date().getTime() + Math.random() * 1000
        let filename = `账户提现记录${time}`
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType //Optional
        })
        this.downloadLoading = false;
      })
    },
    formatJson(jsonData) {
      return jsonData.map(v =>{
         let {
          company_name,
          outer_trade_no,
          bank_account_name,
          id_number,
          money,
          channel_name,
          rate_type,
          card_attribute,
          remark,
          send_msg,
          error_code,
          error_msg,
          created_at
        } = v
        return [ company_name, outer_trade_no, bank_account_name, id_number, money,channel_name,rate_type, card_attribute, remark, send_msg, error_code, error_msg, created_at]
      })
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    // 响应添加按钮
    async addButton() {
      this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id) {
      this.$router.push(this.$route.path+'/'+id+'/view')
    },
    // 响应编辑按钮
    async editButton(id) {
      this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteTradeWithdraw(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.init('del')
        })
      } else {
        this.$message.error(info)
      }

    },

    // 文章添加附件
    tradeWithdrawAttachment(row) {
      this.currentTradeWithdrawId = row.id
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '附件列表（'+row.title+'）'
      this.initTradeWithdrawAttachmentList()
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // //初始化导出文章列表
    // async exportTradeWithdrawList() {
    //   let searchCondition = {}
    //   searchCondition.page_size= 10000
    //   searchCondition.current_page = 1;
    //   var {list} = await this.$api.getAdminTradeWithdrawList(searchCondition)
    //   return list
    // },
      //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 初始化列表
    async init(type) {
      if (type) {
        this.mxResetPage()
      }
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if (type == 'export') {
        pagingInfo.page_size = 50000
      } else {
        this.loadingStaus = true
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.getAdminTradeWithdrawList(searchCondition)
      if(type == 'export') {
        return list
      } else {
        this.tradeWithdrawList = []
        this.$nextTick(() => {
          this.tradeWithdrawList=list
          this.tradeWithdrawList.forEach(item => {
            switch(item.pid) {
              case 'ws': item.pid = '网商银行'; break;
              case 'yinglin': item.pid = '银灵科技'; break;
              default: break;
            }
          })
        })
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus=false
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      // if (this.searchCondition.id) {
      //   condition.id = this.searchCondition.id
      // }
      if (this.searchCondition.bank_account_name) {
        condition.bank_account_name = this.searchCondition.bank_account_name
      }
      if (this.searchCondition.id_number) {
        condition.id_number = this.searchCondition.id_number
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        }
      }
      if (this.searchCondition.card_attribute) {
        condition.card_attribute = this.searchCondition.card_attribute
      }
      if (this.searchCondition.send_status) {
        condition.send_status = this.searchCondition.send_status
      }
      if (this.searchCondition.month) {
        condition.time = {
          start_time: this.searchCondition.month[0],
          end_time: this.searchCondition.month[1],
        }
      }
      if (this.searchCondition.company_ids || this.searchCondition.channel_accounts) {
        condition.company_ids = this.searchCondition.company_ids
        condition.channel_accounts = this.searchCondition.channel_accounts
      }
      return condition
    },
    // 获取文章分类列表
    async getCategoryList() {
      // 获取文章分类列表
      let {list} = await this.$api.getTradeWithdrawCategoryList()
      this.searchCategory = list
    },
    // 初始化文件附件列表
    async initTradeWithdrawAttachmentList() {
      let list = await this.$api.getTradeWithdrawAttachment(this.currentTradeWithdrawId)
      this.attachmentList = list
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment_id = file.id
      this.attachmentUploadFileList = fileList
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment_id = 0
      this.attachmentUploadFileList = fileList
    },
    // form数据提交，请求接口,文章附件
    async formSubmit() {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      this.formData.tradeWithdraw_id = this.currentTradeWithdrawId
      let id = await this.$api.saveTradeWithdrawAttachment(this.formData)
      this.$nextTick(() => {
        this.dialogClose()
      })
      this.$nextTick(() => {
        if (id) {
          this.initTradeWithdrawAttachmentList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['tradeWithdrawAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.attachmentUploadFileList = []
    },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true
      this.dialogData.loading = false
      this.dialogData.title = '添加附件'
    },
    // 相应删除文章附件按钮
    async deleteTradeWithdrawAttachmentButton(id) {
      let info = await this.$api.deleteTradeWithdrawAttachment(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initTradeWithdrawAttachmentList()
        })
      } else {
        this.$message.error(info)
      }

    },
    keyupSubmit(){
      document.onkeydown = e => {
        console.log(e)
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },

  created() {
    this.keyupSubmit()
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .el-table
    font-size: 14px;
  .table-right
    float: right;
    // margin-left: 10px;
  .select-box
    width: 100px;
  .el-tag
    font-size 14px
    font-weight bold
    line-height 38px
    height 38px
  .second-row
    display: flex
    flex-wrap: wrap
    line-height: 55px
    margin-top: -10px
    margin-bottom: 0
  .table-search
    height: 36px
</style>
